export default {
  common: {
    save: 'Lưu',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    delete: 'Xóa',
    edit: 'Sửa',
    add: 'Thêm',
    search: 'Tìm kiếm',
    back: 'Quay lại',
    home: 'Trang chủ',
    language: 'Ngôn ngữ',
    refresh: 'Làm mới',
    viewAll: 'Xem tất cả',
    viewDetailedReport: 'Xem báo cáo chi tiết',
    noData: 'Không có dữ liệu',
    undefined: 'Không xác định',
    success: 'thành công',
    actions: {
      label: 'Thao tác',
      selectAll: 'Chọn tất cả',
      deselectAll: 'Bỏ chọn tất cả',
      add: 'Thêm',
      update: 'Cập nhật',
      close: 'Đóng'
    },
    pagination: {
      total: 'Tổng số',
      page: 'Trang',
      perPage: 'Số dòng mỗi trang'
    },
    filters: {
      apply: 'Áp dụng',
      reset: 'Làm mới',
      advanced: 'Bộ lọc nâng cao',
      active: 'Đang áp dụng:',
      columnDisplay: 'Tùy chỉnh cột hiển thị',
      search: 'Tìm kiếm',
      from: 'Từ',
      to: 'Đến',
      all: 'Tất cả',
      selectYear: 'Chọn năm',
      selectQuarter: 'Chọn quý',
      currentYear: 'Năm hiện tại',
      previousYear: 'Năm trước',
      year: 'Năm',
      quarter: 'Quý',
      startDate: 'Từ ngày',
      endDate: 'Đến ngày'
    }
  },
  menu: {
    dashboard: 'Bảng điều khiển',
    expenses: 'Quản lý chi phí',
    categories: 'Danh mục',
    reports: 'Báo cáo',
    accountHolders: 'Chủ tài khoản'
  },
  navbar: {
    profile: 'Hồ sơ',
    logout: 'Đăng xuất',
    settings: 'Cài đặt'
  },
  auth: {
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    email: 'Email',
    password: 'Mật khẩu'
  },
  dashboard: {
    title: 'Bảng điều khiển',
    summary: 'Tổng quan',
    expenses: 'Chi phí',
    categories: 'Danh mục',
    reports: 'Báo cáo',
    welcome: 'Chào mừng đến với LTV Cocktail',
    editor: {
      welcome: 'Chào mừng đến với Bảng điều khiển Biên tập viên'
    },
    guest: {
      welcome: 'Chào mừng đến với Bảng điều khiển Khách'
    },
    stats: {
      totalExpense: 'Tổng chi phí',
      categories: 'Danh mục',
      expenseCount: 'Số khoản chi phí',
      accountHolders: 'Chủ tài khoản',
      total: 'Tổng'
    },
    chart: {
      quarterlyExpenses: 'Chi phí theo quý',
      year: 'Năm',
      recentExpenses: 'Chi phí gần đây',
      noExpensesInMonth: 'Không có chi phí trong tháng đã chọn',
      selectYear: 'Chọn năm',
      selectMonth: 'Chọn tháng'
    },
    table: {
      paymentDate: 'Ngày thanh toán',
      expenseType: 'Loại chi phí',
      category: 'Danh mục',
      description: 'Mô tả',
      amount: 'Số tiền',
      accountHolder: 'Chủ tài khoản',
      actions: 'Thao tác'
    }
  },
  expenses: {
    title: 'Quản lý chi phí',
    actions: {
      add: 'Thêm chi phí',
      edit: 'Sửa chi phí',
      delete: 'Xóa',
      approve: 'Duyệt',
      reject: 'Từ chối',
      markAsPaid: 'Đánh dấu đã thanh toán',
      import: 'Nhập dữ liệu'
    },
    form: {
      paymentDate: 'Ngày thanh toán',
      expenseType: 'Loại chi phí',
      category: 'Danh mục',
      description: 'Mô tả',
      amount: 'Số tiền',
      accountHolder: 'Chủ tài khoản',
      status: 'Trạng thái',
      accountNumber: 'Số tài khoản',
      bankName: 'Ngân hàng',
      note: 'Ghi chú',
      document: 'Tài liệu',
      invoicePdf: 'Hóa đơn PDF',
      invoiceXml: 'Hóa đơn XML'
    },
    filters: {
      expenseType: 'Loại chi phí',
      category: 'Danh mục',
      status: 'Trạng thái',
      accountHolder: 'Chủ tài khoản',
      accountNumber: 'Số tài khoản',
      bankName: 'Ngân hàng',
      minAmount: 'Số tiền từ',
      maxAmount: 'Số tiền đến',
      note: 'Ghi chú',
      dateRange: 'Khoảng thời gian',
      startDate: 'Từ ngày',
      endDate: 'Đến ngày'
    },
    status: {
      approved: 'Đã duyệt',
      pending: 'Chờ duyệt',
      paid: 'Đã thanh toán',
      rejected: 'Từ chối'
    },
    stats: {
      approved: 'Đã duyệt',
      pending: 'Chờ duyệt',
      paid: 'Đã thanh toán',
      rejected: 'Từ chối',
      total: 'Tổng'
    },
    table: {
      paymentDate: 'Ngày thanh toán',
      expenseType: 'Loại chi phí',
      category: 'Danh mục',
      description: 'Mô tả',
      amount: 'Số tiền',
      accountHolder: 'Chủ tài khoản',
      accountNumber: 'Số tài khoản',
      bankName: 'Ngân hàng',
      status: 'Trạng thái',
      note: 'Ghi chú',
      actions: 'Thao tác'
    },
    import: {
      processing: 'Đang xử lý dữ liệu...',
      importing: 'Đang nhập dữ liệu...',
      confirmation: 'Xác nhận nhập {count} chi phí từ file Excel?',
      confirmTitle: 'Xác nhận nhập dữ liệu',
      importButton: 'Nhập',
      success: 'Đã nhập {count} chi phí thành công',
      templateInfoTitle: 'Thông tin mẫu nhập',
      templateInstructions: 'File Excel cần có các cột sau:',
      downloadQuestion: 'Bạn muốn tải mẫu Excel không?',
      downloadTemplate: 'Tải mẫu',
      templateSheetName: 'Mẫu nhập chi phí',
      templateFileName: 'mau_nhap_chi_phi.xlsx',
      fields: {
        paymentDate: 'Ngày thanh toán (định dạng YYYY-MM-DD)',
        expenseType: 'Loại chi phí',
        category: 'Danh mục',
        description: 'Mô tả',
        amount: 'Số tiền',
        accountHolder: 'Chủ tài khoản',
        accountNumber: 'Số tài khoản',
        bankName: 'Ngân hàng',
        status: 'Trạng thái (Chờ duyệt, Đã duyệt, Đã thanh toán, Từ chối)',
        note: 'Ghi chú'
      },
      examples: {
        mealType: 'Tiếp khách',
        mealCategory: 'Ăn uống',
        mealDesc: 'Tiếp khách đối tác ABC',
        mealNote: 'Hóa đơn đã đính kèm',
        suppliesType: 'Văn phòng phẩm',
        suppliesCategory: 'Dụng cụ văn phòng',
        suppliesDesc: 'Mua giấy A4, bút và kẹp giấy',
        suppliesNote: 'Mua tại Fahasa',
        transportType: 'Đi lại',
        transportCategory: 'Giao thông',
        transportDesc: 'Taxi đi gặp khách hàng XYZ',
        transportNote: 'Kèm biên lai taxi',
        utilityType: 'Hóa đơn',
        utilityCategory: 'Điện nước',
        utilityDesc: 'Tiền điện tháng 5 văn phòng',
        utilityNote: 'Hóa đơn điện tử',
        person1: 'Nguyễn Văn A',
        person2: 'Trần Thị B',
        person3: 'Lê Văn C',
        person4: 'Phạm Thị D'
      },
      errors: {
        cannotRead: 'Không thể đọc file',
        readError: 'Lỗi đọc file Excel',
        processingError: 'Lỗi xử lý file Excel',
        missingHeaders: 'Thiếu các cột bắt buộc: {headers}',
        noData: 'Không có dữ liệu để nhập',
        importError: 'Lỗi nhập dữ liệu',
        excelImportError: 'Lỗi nhập dữ liệu từ Excel',
        rowError: 'Dòng {row}: {message}'
      }
    }
  },
  categories: {
    title: 'Danh mục',
    add: 'Thêm danh mục',
    edit: 'Sửa danh mục',
    name: 'Tên',
    description: 'Mô tả',
    code: 'Mã danh mục',
    codeHelpText: 'Mã không quá 10 ký tự, không được trùng lặp',
    deleteConfirmation: 'Bạn có chắc chắn muốn xóa danh mục này?',
    deleteSuccess: 'Xóa danh mục thành công',
    validation: {
      nameRequired: 'Tên danh mục không được để trống',
      codeRequired: 'Mã danh mục không được để trống',
      codeDuplicate: 'Mã danh mục đã tồn tại, vui lòng chọn mã khác'
    }
  },
  reports: {
    title: 'Báo cáo chi phí',
    overview: {
      title: 'Tổng quan',
      totalExpense: 'Tổng chi phí',
      quarterlyBreakdown: 'Phân bổ theo quý',
      yearlyBreakdown: 'Phân bổ theo năm'
    },
    timeRange: {
      allYears: 'Tất cả các năm',
      currentYear: 'Năm hiện tại',
      previousYear: 'Năm trước',
      year: 'Năm {year}'
    },
    charts: {
      byTime: {
        title: 'Phân bổ theo thời gian',
        yearlyTitle: 'Tổng chi phí phân bổ theo từng năm',
        quarterlyTitle: 'Tổng chi phí phân bổ theo quý',
        selectYears: 'Chọn năm (mặc định: tất cả)'
      },
      byType: {
        title: 'Phân loại chi phí',
        subtitle: 'Tổng chi phí theo loại chi phí'
      },
      byCategory: {
        title: 'Phân loại danh mục',
        subtitle: 'Tổng chi phí theo danh mục'
      },
      byAccountHolder: {
        title: 'Phân loại chủ tài khoản',
        subtitle: 'Tổng chi phí theo chủ tài khoản'
      },
      detailedExpenses: {
        title: 'Chi tiết giao dịch',
        subtitle: 'Danh sách chi tiết chi phí'
      }
    },
    filters: {
      timeRange: 'Chọn thời gian',
      year: 'Chọn năm',
      quarter: 'Chọn quý',
      expenseType: 'Loại chi phí',
      category: 'Danh mục',
      accountHolder: 'Chủ tài khoản'
    },
    table: {
      year: 'Năm',
      quarter: 'Quý',
      totalAmount: 'Tổng chi phí',
      expenseType: 'Loại chi phí',
      category: 'Danh mục',
      accountHolder: 'Chủ tài khoản',
      paymentDate: 'Ngày thanh toán',
      description: 'Mô tả',
      amount: 'Số tiền',
      status: 'Trạng thái'
    }
  },
  accountHolders: {
    title: 'Quản lý chủ tài khoản',
    add: 'Thêm chủ tài khoản',
    edit: 'Sửa chủ tài khoản',
    name: 'Tên chủ tài khoản',
    accountNumber: 'Số tài khoản',
    bank: 'Ngân hàng',
    note: 'Ghi chú',
    expenseCount: 'Số chi phí'
  },
  error: {
    notFound: 'Không tìm thấy trang',
    unauthorized: 'Không có quyền truy cập',
    serverError: 'Lỗi máy chủ',
    backHome: 'Quay về trang chủ',
    loadingRecentExpenses: 'Không thể tải dữ liệu chi phí gần đây',
    loadingQuarterlyExpenses: 'Không thể tải dữ liệu chi phí theo quý',
    loadingStats: 'Không thể tải dữ liệu thống kê',
    futureYearWarning: 'Đã chuyển sang năm hiện tại vì không thể truy vấn dữ liệu trong tương lai',
    refreshData: 'Không thể tải lại dữ liệu',
    savingCategory: 'Có lỗi xảy ra khi lưu danh mục',
    deletingCategory: 'Có lỗi xảy ra khi xóa danh mục',
    fetchingCategories: 'Không thể tải danh sách danh mục'
  },
  info: {
    refreshing: 'Đang tải lại dữ liệu...',
    refreshSuccess: 'Dữ liệu đã được cập nhật',
    dataLoaded: 'Đã tải dữ liệu thành công',
    periodSelected: 'Khoảng thời gian đã chọn'
  }
} 